$(document).on('ready', function () {
  var params = paramsToObject();
  if (params['order-page-redirect'] === 'true') {
    $('#js__find-tests').click();
  }
});
